<template>
  <div
    class="mdc-layout-grid"
    :class="styleClasses"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MaterialGridContainer',
  props: {
    fixedColumnWidth: {
      type: Boolean,
      default: false
    },
    alignment: {
      type: String,
      default: ''
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleClasses () {
      return {
        'mdc-layout-grid--debug': this.debug,
        'mdc-layout-grid--fixed-column-width': this.fixedColumnWidth,
        [`mdc-layout-grid--align-${this.alignment}`]: !!this.alignment
      }
    }
  }
}
</script>

<style lang="scss">
@import "./variables.scss";
@import "@material/layout-grid/mdc-layout-grid";

.mdc-layout-grid--debug {
  background-color: gray;

  .mdc-layout-grid__inner {
    padding: 15px;
    background-color: lighten(gray, 10)
  }

  .mdc-layout-grid__cell {
    padding: 15px;
    background-color: lighten(gray, 30)
  }
}
</style>
